import React, { useState } from "react";
import { Popover } from "@mui/material";
import useriocn from "../../../assets/images/useriocn.png";
import orderimg from "../../../assets/images/orderimg.png";
import {
  NotificationBTn,
  LogoutBTn,
  PopoverWrape,
  UserAvatar,
} from "./styles/UserInfoPopupStyle";
import { useDispatch, useSelector } from "react-redux";
import { AdminSignouthandler } from "../../../services/auth/logout";
import SmallLoader from "../../shared/loader/SmallLoader";
import { clearAuthStorage } from "../../../redux/slice/user/UserSlice";

const UserInfoPopup = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();
  const { user: useInfo = {} } = useSelector((state) => state.auth);

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  const Logouthandler = async () => {
    setLoading(true);
    try {
      const res = await AdminSignouthandler();
      if (res && res.status === 200) {
        dispatch(clearAuthStorage());
      }
    } catch (error) {
      console.error("Logout Error:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <NotificationBTn
        variant="contained"
        color="primary"
        startIcon={<img src={useriocn} alt="useriocn" />}
        disableRipple
        onClick={handleClick}
      />
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            width: "300px",
            padding: "10px",
            borderRadius: "inherit",
          },
        }}
      >
        <PopoverWrape>
          <UserAvatar alt={orderimg} src={orderimg} />
          <div className="userimfo">
            <h6>{useInfo && useInfo?.name}</h6>
            <p>{useInfo && useInfo?.email}</p>
          </div>
          <div className="logoutbtn">
            <LogoutBTn onClick={Logouthandler} disabled={loading}>
              {loading ? <SmallLoader smallSize={true} /> : "Logout"}
            </LogoutBTn>
          </div>
        </PopoverWrape>
      </Popover>
    </>
  );
};

export default UserInfoPopup;
